import _styled from 'styled-components';
import { memo } from 'react';
import { useIconByReference, ADMIN_IMAGES } from '@dbh/images-redux';
import '@dbh/generic-types';
import useFormattedMessage from '@dbh/use-formatted-message-hook';
import { withPadding } from '@dbh/styled-helpers';
import { jsx } from 'react/jsx-runtime';

/*
 *
 * Constants: `@dbh/rating-stars`.
 *
 */const TRANSLATION_IDS=Object.freeze({description:"global.hotel_stars"});

const RatingStars=/*#__PURE__*/memo(a=>{let{stars:b,descriptionTranslationKey:d=TRANSLATION_IDS.description,...c}=a;const e=useIconByReference(ADMIN_IMAGES.STAR),f=useFormattedMessage(d,{stars:b}),g=Array.from(Array(b).keys()),h=g.map(()=>"url("+e+")").toString();return/*#__PURE__*/jsx(_StyledDiv,{"aria-label":f,starsRange:g,...c,$_css:h,$_css2:.05*(g.length-1),$_css3:g.length})});RatingStars.displayName="RatingStars";var _StyledDiv=/*#__PURE__*/_styled("div").withConfig({componentId:"sc-1agl2kb-0"})(["display:inline-flex;",";",";background-image:",";background-repeat:no-repeat;background-position:",";width:calc( ( 1.2rem + ","rem ) * "," );height:1.2rem;"],withPadding,a=>{let{verticalAlign:b}=a;return b&&"vertical-align: "+b},a=>a.$_css,a=>{let{starsRange:b,...c}=a;return b.map(a=>"calc((1.2rem + .2rem) * "+a+") top").toString()},a=>a.$_css2,a=>a.$_css3);

export { TRANSLATION_IDS, RatingStars as default };
